import styles from './styles.module.css'
import { useState, useRef, useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { useClient } from '../../hooks/useClient'

import StepFirstPass from './StepfirstPass'
import NewPostFormSecond from './StepfirstPass'
import StepThirdPass from './StepThirdPass'

import StepImageBank from './StepfirstPass/StepImageBank'
import StepFourthPass from './StepFourthPass'
import StepFinish from './StepFinish'

import StepPublicationSuccess from './StepPublicationSuccess'
import StepMyPublication from './StepMyPublication'
import StepNinche from './StepNinche'
import StepColorPalette from './stepColorPalette'
import { motion } from 'framer-motion'
import { getBusinessByClientId } from '../../services/business'
import { BusinessService, SubscriptionService } from '../../services'
import Loading from '../../components/Loading'
import { UseCheckArtPending } from '../../hooks/useCheckArtPending'

const STEPS = {
  STEP_FIRST_PASS: 'stepFirstPass',
  STEP_SECOND_PASS_IMAGE: 'stepImage',
  STEP_THIRD_PASS_PUBLICATION: 'stepArts',
  STEP_FOURTH_PASS_SUBTITLE: 'stepSubtitles',

  STEP_FINISH: 'stepFinish',
  STEP_PUBLICATION_SUCCESS: 'stepPublicationSuccess',

  STEP_IMAGE_BANK: 'stepImageBank',
  STEP_MY_PUBLICATION: 'stepMyPublication',
  STEP_NINCHE: 'stepNinche',
  STEP_COLOR_PALETTE: 'stepColorPalette',
}

export default function NewPublicationPageIA() {
  const { clientData } = useClient()
  const location = useLocation()
  const navigate = useNavigate()
  const isInitialParameterizationFlow =
    location.state?.initialParameterization === true

  const [step, setStep] = useState('')

  const editRef = useRef(false)
  const editDataRef = useRef(undefined)

  const productRef = useRef(undefined)
  const targetAudienceRef = useRef(undefined)
  const publicationDescriptionRef = useRef('')
  const funelOfSaleRef = useRef(undefined)
  const detailRef = useRef(undefined)

  const [imageGaleryArray, setImageGaleryArray] = useState([])
  const [imageArray, setImageArray] = useState([])
  const [imageAIArray, setImageAIArray] = useState([])
  const [imageUploadArray, setImageUploadArray] = useState([])
  const [imageProductsArray, setImageProductsArray] = useState([])
  const [hasSignature, setHasSignature] = useState(false)
  const [generateArtIa, setGenerateArtIa] = useState(false)
  const [selectedFormat, setSelectedFormat] = useState(null)
  const [referenceArt, setReferenceArt] = useState(null)

  const [iaData, setIaData] = useState([
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
  ])
  const [qtdLoadTemplates, setQtdLoadTemplates] = useState(0)

  // const qtdTemplatesLimit = 6
  const qtdTemplatesLimit = 0

  const [imageUrl, setImageUrl] = useState('')
  const [imageLayers, setImageLayers] = useState([])
  const [headlineText, setHeadlineText] = useState('')

  const [headlineList, setHeadlineList] = useState([])
  const [legendList, setLegendList] = useState([])

  const [legend, setLegend] = useState(false)

  const [publicationDraft, setPublicationDraft] = useState({})
  const [draft, setDraft] = useState(false)

  const [repost, setRepost] = useState(false)
  const [schedule, setSchedule] = useState(false)
  const [nincheData, setNincheData] = useState({})

  const [templateId, setTemplateId] = useState('')

  const [userNiche, setUserNiche] = useState('')
  const [selectFunnel, setselectFunnel] = useState({})
  const [headlineGpt, setHeadlineGpt] = useState({})

  const publicationIdRef = useRef(undefined)
  const [currentIndex, setCurrentIndex] = useState(0)

  const returnToStepRef = useRef(false)

  const [colorsArray, setColorsArray] = useState([])
  const [overlay, setOverlay] = useState(false)
  const [loading, setLoading] = useState(false)

  const [loadingClean, setLoadingClean] = useState(true)
  const [flowCode, setFlowCode] = useState('')

  const [isAnimationFinished, setIsAnimationFinished] = useState(false)

  const { handleVerifyHasArtPending, artStatus } = UseCheckArtPending()

  const [selectedImageType, setSelectedImageType] = useState(null)

  // useEffect(() => {
  //   setLoadingClean(true)

  //   if (location?.state?.dashboad) {
  //     const gptData = JSON.parse(location?.state?.gptData)

  //     setLegend(gptData?.data?.data?.legend[location.state.indexModalSelected])

  //     setImageUrl(location?.state?.img)
  //     setImageLayers(location?.state?.layers)

  //     setStep(STEPS.STEP_FINISH)

  //     return
  //   }

  //   if (location?.state?.edit) {
  //     editRef.current = true
  //     editDataRef.current = location?.state?.dataPublication

  //     setImageUrl(
  //       'data:image/png;base64,' +
  //         location?.state?.dataPublication?.generateArtJson.srcComTratativa
  //     )

  //     setLegend(location?.state?.dataPublication?.legend)

  //     setStep(STEPS.STEP_FINISH)
  //     return
  //   }

  //   productRef.current = undefined
  //   targetAudienceRef.current = undefined
  //   publicationDescriptionRef.current = ''
  //   funelOfSaleRef.current = undefined
  //   detailRef.current = undefined

  //   setStep(STEPS.STEP_FIRST_PASS)
  // }, [clientData])

  useEffect(() => {
    handleSendToArtPending()
  }, [artStatus])

  useEffect(() => {
    setStep(location?.state?.step || step)

  }, [location?.state?.step])


  useEffect(() => {
    (async () => {
      // Aguarda verificação de artStatus primeiro
      await handleVerifyHasArtPending()

      await handleCreateFlowCode()
      const hasAccess = await handleCheckSubscription()
      if (!hasAccess) {
        setLoadingClean(false)
        return
      }

      // Sempre chama getUserNiche para verificar business
      await getUserNiche()

      // Remove loading após tudo carregar
      setLoadingClean(false)
    })()
  }, [])


  const handleSendToArtPending = () => {
    if (location?.state?.step) return

    // if(artStatus && !artStatus.isVisualized){
    //   setStep(STEPS.STEP_FOURTH_PASS_SUBTITLE)
    //   return
    // } else {
    //   if (step === STEPS.STEP_FOURTH_PASS_SUBTITLE && artStatus?.imageUrl) {
    //     return
    //   }
    // Só seta FIRST_PASS se step ainda estiver vazio ou indefinido
    // Não sobrescrever se step já foi definido por getUserNiche
    // if(step === '' || step === STEPS.STEP_FOURTH_PASS_SUBTITLE) {
    //   setStep(STEPS.STEP_FIRST_PASS)
    // }
    // }
  }

  const handleCreateFlowCode = async () => {
    const timestamp = Date.now().toString(36);

    // Adiciona 2 caracteres aleatórios só para variar mais
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomPart = '';
    for (let i = 0; i < 2; i++) {
      randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    // Junta timestamp + aleatório e corta para no máximo 7 caracteres
    setFlowCode(timestamp + randomPart)?.substring(0, 7);

  }

  const handleCheckSubscription = async () => {
    const subscription = await SubscriptionService.getSubscriptionByUser()

    if (subscription.data.length <= 0) {
      setHasSignature(false)
    } else {
      setHasSignature(true)
    }

    return true
  }

  const getUserNiche = async () => {
    let businessId

    if (clientData?.uuid) {
      const { data } = await getBusinessByClientId(clientData?.uuid)
      businessId = data[0]?.BusinessNiche?.name
    } else {
      const { data } = await BusinessService.getBusinessByLogin()

      // Só definir step se não houver art pendente
      if ((!artStatus || artStatus.isVisualized)) {
        setStep(STEPS.STEP_FIRST_PASS)
        setOverlay(false)
      }
      businessId = data[0]?.BusinessNiche?.name
    }
    setUserNiche(businessId)
  }

  return (
    <div className={styles.page}>
      {loadingClean && <Loading enable={loadingClean} />}

      {!loadingClean && (
        <>
          <Loading enable={loading} />
          {overlay && <div className={styles.overlay}></div>}
          {step === STEPS.STEP_FIRST_PASS && (
            <motion.div
              // key={expanded}
              initial={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{ width: '100%' }}
              onAnimationComplete={() => setIsAnimationFinished(true)}
            >
              {

                <StepFirstPass
                  isAnimationFinished={isAnimationFinished}
                  setStep={setStep}
                  clientData={clientData}
                  productRef={productRef}
                  targetAudienceRef={targetAudienceRef}
                  publicationDescriptionRef={publicationDescriptionRef}
                  funelOfSaleRef={funelOfSaleRef}
                  detailRef={detailRef}
                  setselectFunnel={setselectFunnel}
                  //!==========
                  imageArray={imageArray}
                  setImageArray={setImageArray}
                  imageGaleryArray={imageGaleryArray}
                  setImageGaleryArray={setImageGaleryArray}
                  imageAIArray={imageAIArray}
                  setImageAIArray={setImageAIArray}
                  imageUploadArray={imageUploadArray}
                  setImageUploadArray={setImageUploadArray}
                  imageProductsArray={imageProductsArray}
                  setImageProductsArray={setImageProductsArray}
                  setGenerateArtIa={setGenerateArtIa}
                  generateArtIa={generateArtIa}
                  setSelectedFormat={setSelectedFormat}
                  selectedFormat={selectedFormat}
                  returnToStepRef={returnToStepRef}
                  referenceArt={referenceArt}
                  setReferenceArt={setReferenceArt}
                  selectedImageType={selectedImageType}
                  setSelectedImageType={setSelectedImageType}
                />

              }
            </motion.div>
          )}

          {step === STEPS.STEP_IMAGE_BANK && (
            <motion.div
              // key={expanded}
              initial={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{ width: '100%' }}
            >
              <StepImageBank
                setStep={setStep}
                imageArray={imageArray}
                imageGaleryArray={imageGaleryArray}
                setImageGaleryArray={setImageGaleryArray}
                imageAIArray={imageAIArray}
                setImageAIArray={setImageAIArray}
                imageUploadArray={imageUploadArray}
                setImageUploadArray={setImageUploadArray}
                imageProductsArray={imageProductsArray}
                setImageProductsArray={setImageProductsArray}
                selectedImageType={selectedImageType}
                setImageArray={setImageArray}
                setSelectedImageType={setSelectedImageType}
              />
            </motion.div>
          )}

          {step === STEPS.STEP_SECOND_PASS_IMAGE && (
            <motion.div
              initial={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{ width: '100%' }}
            >
              <NewPostFormSecond
                setStep={setStep}
                imageArray={imageArray}
                setImageArray={setImageArray}
                imageGaleryArray={imageGaleryArray}
                setImageGaleryArray={setImageGaleryArray}
                imageAIArray={imageAIArray}
                setImageAIArray={setImageAIArray}
                imageUploadArray={imageUploadArray}
                setImageUploadArray={setImageUploadArray}
                imageProductsArray={imageProductsArray}
                setImageProductsArray={setImageProductsArray}
                productRef={productRef}
                targetAudienceRef={targetAudienceRef}
                generateArtIa={generateArtIa}
                setGenerateArtIa={setGenerateArtIa}
              />
            </motion.div>
          )}

          {step === STEPS.STEP_FOURTH_PASS_SUBTITLE && (
            <motion.div
              initial={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{ width: '100%' }}
            >
              <StepFourthPass
                setStep={setStep}
                productRef={productRef}
                targetAudienceRef={targetAudienceRef}
                imageUrl={imageUrl}
                imageLayers={imageLayers}
                setImageUrl={setImageUrl}
                setHeadlineText={setHeadlineText}
                headlineText={headlineText}
                legend={legend}
                setLegend={setLegend}
                draftData={publicationDraft}
                publicationRet={location.state?.dataPublication}
                draft={draft}
                repost={repost}
                schedule={schedule}
                setHeadlineList={setHeadlineList}
                headlineList={headlineList}
                setLegendList={setLegendList}
                legendList={legendList}
                selectFunnel={selectFunnel}
                headlineGpt={headlineGpt}
                setCurrentIndex={setCurrentIndex}
                publicationDescriptionRef={publicationDescriptionRef}
                //!==========
                qtdLoadTemplates={qtdLoadTemplates}
                setQtdLoadTemplates={setQtdLoadTemplates}
                qtdTemplatesLimit={qtdTemplatesLimit}
                imageArray={imageArray}
                setHeadlineGpt={setHeadlineGpt}
                nincheData={nincheData}
                generateArtIa={generateArtIa}
                hasSignature={hasSignature}
                imageGaleryArray={imageGaleryArray}
                imageAIArray={imageAIArray}
                imageUploadArray={imageUploadArray}
                imageProductsArray={imageProductsArray}
                setIaData={setIaData}
                iaData={iaData}
                setImageLayers={setImageLayers}
                setSelectedFormat={setSelectedFormat}
                selectedFormat={selectedFormat}
                returnToStepRef={returnToStepRef}
                flowCode={flowCode}
                referenceArt={referenceArt}
              //!==========
              />
            </motion.div>
          )}

          {step === STEPS.STEP_FINISH && (
            <StepFinish
              setStep={setStep}
              productRef={productRef}
              targetAudienceRef={targetAudienceRef}
              imageUrl={imageUrl}
              imageLayers={imageLayers}
              setImageUrl={setImageUrl}
              headlineText={headlineText}
              setHeadlineText={setHeadlineText}
              legend={legend}
              setLegend={setLegend}
              setHeadlineList={setHeadlineList}
              headlineList={headlineList}
              setLegendList={setLegendList}
              legendList={legendList}
              draftModalData={publicationDraft}
              publicationIdRef={publicationIdRef}
              editRef={editRef}
              editDataRef={editDataRef}
              currentIndex={currentIndex}
              dashParam={location?.state?.dashboad}
              returnToStepRef={returnToStepRef}
              flowCode={flowCode}
            />
          )}

          {step === STEPS.STEP_MY_PUBLICATION && (
            <StepMyPublication
              setStep={setStep}
              publicationIdRef={publicationIdRef}
              imageUrl={imageUrl}
              setImageUrl={setImageUrl}
            />
          )}

          {step === STEPS.STEP_PUBLICATION_SUCCESS && (
            <StepPublicationSuccess
              imageUrl={imageUrl}
              publicationIdRef={publicationIdRef}
              flowCode={flowCode}
            />
          )}

          {step === STEPS.STEP_NINCHE && (
            <StepNinche
              setStep={setStep}
              colorsArray={colorsArray}
              setOverlay={setOverlay}
              setLoading={setLoading}
              initialParameterizationFlow={isInitialParameterizationFlow}
            />
          )}
          {step === STEPS.STEP_COLOR_PALETTE && (
            <StepColorPalette
              setStep={setStep}
              setColorsArray={setColorsArray}
              colorsArray={colorsArray}
            // businessAccountData={businessAccountData}
            />
          )}
        </>
      )}
    </div>
  )
}
